/** /download/ 页正文 */
export const downloadSections = [
	{
		h2: 'About this download',
		paragraphs: [
			'This page links to the GB WhatsApp Pro APK below. We show version v18.80 and the measured file size so you can compare before tapping Install.',
			'GB WhatsApp Pro is unofficial software. Read safety information and back up chats in the Installation hub before you sideload.',
		],
	},
	{
		h2: 'Download instructions',
		steps: [
			'Tap Download and wait for the APK to finish on Wi‑Fi.',
			'Open the file from Downloads or the browser notification.',
			'Allow installation from that source if Android prompts you.',
			'Install, open the app, and complete SMS verification.',
		],
	},
	{
		h2: 'Android install permission',
		paragraphs: [
			'Android blocks unknown APKs by default because sideloading can install apps that never passed Play Store review. When you open a downloaded file, the system asks which app may install packages—usually Chrome, Samsung Internet, or the Files app—not GB WhatsApp Pro itself.',
			'Grant permission only to the app you trust to open installers. You do not need a global “install unknown apps from everywhere” setting on modern Android unless your manufacturer hides per-app toggles. After a successful install, you can leave the permission on for that browser or turn it off if you rarely sideload.',
			'Samsung, Xiaomi, Oppo, and Huawei sometimes add an extra security scan before Install appears. Wait for the scan to finish; canceling early can look like a failed install. If the dialog mentions Play Protect, read the full text—you are choosing to proceed after understanding the warning, not bypassing security silently.',
		],
		list: [
			'Settings → Apps → Special access → Install unknown apps → pick Chrome or Files → Allow',
			'If Install is greyed out, free storage and confirm the APK download completed (check file size in Downloads)',
			'Enterprise or school devices may block sideloading entirely—official WhatsApp from an allowed store may be the only option',
		],
	},
	{
		h2: 'Download troubleshooting',
		paragraphs: [
			'Most “Problem parsing package” or “App not installed” errors on a fresh download trace back to an incomplete file, wrong architecture, or a blocked install—not a broken phone. Start by deleting the APK, clearing the browser download queue, and fetching the file again on stable Wi‑Fi.',
			'If the progress bar stalled or your connection dropped, Android may still show a file in Downloads with a plausible name but missing megabytes. Compare the saved file’s size with the published figure on this page before tapping Install again.',
			'When retries fail with the same error text, capture a screenshot of the message and your Android version, then work through the not-installing and Android-install chapters linked below instead of hopping between random mirror sites.',
		],
		list: [
			'Download interrupted → delete APK, reboot, retry on Wi‑Fi',
			'Storage full → free at least 500 MB–1 GB before install',
			'Old APK left in Downloads → remove duplicates so you open the newest file only',
			'Install blocked after update → may be signature mismatch; read update-failed help before uninstalling',
		],
	},
	{
		h2: 'Verify before you install',
		paragraphs: [
			'Compare the downloaded file size with the version table on this page (~191.3 MB for the current build). A file tens or hundreds of megabytes smaller is a strong sign of a truncated download or a repackaged fake. Do not install until you have a full-size copy from a source you can reconcile with our published details.',
			'Filename alone is not proof of authenticity—publishers rename APKs often. Note the download time, network, and whether the size in your file manager matches what we list. If you must use another mirror, treat mismatch as a stop signal and read fake-APK warnings in Safety before proceeding.',
			'Charge the phone or keep it plugged in during a large download. On metered mobile data, wait for Wi‑Fi so the transfer is not cut off mid-stream. After download, you can optionally scan with your preferred Android security tool—a clean scan is helpful but not a guarantee of long-term safety for modified apps.',
		],
		list: [
			'Match megabyte size to this page before Install',
			'Avoid Telegram or comment-section links that change daily without size notes',
			'If size matches but behavior feels wrong after install, compare permissions in Android Settings → Apps',
		],
	},
	{
		h2: 'After download',
		paragraphs: [
			'First launch will ask for SMS or voice verification. Insert the SIM that receives texts, disable airplane mode, and avoid requesting codes in rapid succession—carriers and WhatsApp may throttle repeats. If SMS is delayed, use verification help in the Help hub before assuming the APK is corrupt.',
			'If you already use official WhatsApp on the same number, plan backups and read dual-install notes in Installation. One number typically registers on one client at a time; switching without backup can mean chat loss.',
			'After verification, open Settings (and GB Settings if your build has them) and note the version string. Screenshot privacy toggles you care about, then use the check-version chapter in Updates so future APKs match the same publisher line.',
		],
	},
]
